import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { getReportingLocations, getCrewsForBase } from '../hireBaseCrew';

const HireBaseCrewSelect = ({ reportingLocations, hireBase, crew, onChange }) => {
  const [locations, setLocations] = useState(reportingLocations || []);
  const [crews, setCrews] = useState([]);

  useEffect(() => {
    if (reportingLocations?.length) {
      setLocations(reportingLocations);
    } else {
      getReportingLocations().then(setLocations);
    }
  }, [reportingLocations]);

  useEffect(() => {
    if (!hireBase) {
      setCrews([]);
      return;
    }
    getCrewsForBase(hireBase).then(setCrews);
  }, [hireBase]);

  return (
    <>
      <div className='base-select input-holder'>
        <span>
          Base<span style={{ color: 'red' }}>*</span>
        </span>
        <Select
          options={locations.map((loc) => ({ label: loc.value, value: loc.id }))}
          onChange={(selection) =>
            onChange({ hireBase: selection ? selection.value : '', crew: '' })
          }
          value={
            hireBase
              ? { label: locations.find((l) => l.id == hireBase)?.value, value: hireBase }
              : null
          }
          placeholder='Select Base'
          classNamePrefix='select'
          isClearable
        />
      </div>
      <div className='crew-select input-holder'>
        <span>Crew (Optional)</span>
        <Select
          options={crews.map((c) => ({ label: c.resource_name, value: c.id }))}
          onChange={(selection) =>
            onChange({ hireBase, crew: selection ? selection.value : '' })
          }
          value={
            crew
              ? { label: crews.find((c) => c.id == crew)?.resource_name, value: crew }
              : null
          }
          placeholder={hireBase ? 'Select Crew (Optional)' : 'Select a Base first'}
          classNamePrefix='select'
          isDisabled={!hireBase}
          isClearable
        />
      </div>
    </>
  );
};

export default HireBaseCrewSelect;
